import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { postDocumentsComments } from '../requests';
import type { PostDocumentCommentsRequestType } from '../types';

type PostDocumentCommentsRequestTypeMutation = Omit<
  PostDocumentCommentsRequestType,
  'documentId'
>;

export const usePostDocumentComments = (
  documentId: PostDocumentCommentsRequestType['documentId'],
) => {
  const queryClient = useQueryClient();

  const onSuccess = () => {
    queryClient.invalidateQueries([
      API_QUERY_KEYS.documentComments,
      { documentId },
    ]);
  };

  return useMutation({
    mutationFn: (data: PostDocumentCommentsRequestTypeMutation) =>
      postDocumentsComments({
        documentId: documentId!,
        ...data,
      }),
    onSuccess,
  });
};
